import { Http } from "@/util";

export default {
  install(Vue) {
    Vue.$http = Vue.prototype.$http = Http;
  }
};
